import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './pagination-dots.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PaginationDots = props => ___EmotionJSX("div", {
  css: styles.container
}, props.pages.map((page, index) => {
  var isActiveDot = index === props.activeSlide ? styles.largeDot : null;
  return ___EmotionJSX("div", {
    key: index,
    css: /*#__PURE__*/_css([styles.dot, isActiveDot])
  }); // eslint-disable-line react/no-array-index-key
}));
PaginationDots.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  activeSlide: PropTypes.number.isRequired
};
export default PaginationDots;